module.exports = __webpack_public_path__ + "img/102.fa72d1fa.jpg";